module.exports = __webpack_public_path__ + "58cfa964fe598ca665b866fe52490ef9.jpg";